/**
    * YouTubeElement description
    * (c) lg2fabrique 2017
*/
import Youtube from 'frontools/medias/video/Youtube';
import { YoutubeObject } from 'frontools/medias/video/Youtube';

declare var dataLayer: any;
export default class YouTubeElement {
    private _youtubeId          : string;
    private _ytOptions          : YoutubeObject;
    private _video              : Youtube;
    private _isPlaying          : boolean;

    /**
    * constructor
    */
    constructor(id: string, target: HTMLElement) {
        this._ytOptions = new YoutubeObject();
        this._ytOptions.id = id;
        this._ytOptions.target = target;
        this._ytOptions.playerSettings.controls = 2;
        this._ytOptions.playerSettings.autoplay = 0;

        this._video = new Youtube(this._ytOptions);

        this._video.addListener(Youtube.STATE_CHANGE, this._onVideoState.bind(this));
        this._video.addListener(Youtube.PROGRESS_TRACK, this._progressTrack.bind(this));
    }

    private _onVideoState(e) {
        if (e.data === 1 && !this._isPlaying) {
            this._pushDatalayer('play');
            this._isPlaying = true;
        } else if (e.data === 0) { // video ended
            this._pushDatalayer('100%');
        }
    }

    private _progressTrack(e) {
        if(e.second === 30) {
            this._pushDatalayer('30sec');
        } else {
            this._pushDatalayer(e.percent + '%');
        }
    }

    private _pushDatalayer(label: string) {
        // dataLayer.push({ eventCategory: this._pageId, eventAction: 'vidéo histoire', eventLabel: label, event: 'genericGAEvent' });
    }
}
